module.exports = __webpack_public_path__ + "img/partnerurkunde-tourismus-montafon.8b8101b0.webp";